export default {
    downloadLink: "Download Privacy Policy"
}